import { FormGroup, Typography, Checkbox, FormControlLabel, Box, Tooltip } from "@mui/material";

export type YesNoState = "yes" | "no" | null | undefined;

type YesNoCheckBoxesProps = {
  title: string;
  yesLabel: string;
  noLabel: string;
  state: YesNoState;
  tooltipText?: string;
  disabled?: boolean;
  setState: (value: YesNoState) => void;
};

const YesNoCheckBoxes = ({
  title,
  yesLabel = "Yes",
  noLabel = "No",
  state,
  tooltipText,
  disabled,
  setState,
}: YesNoCheckBoxesProps) => {
  return (
    <>
      <Tooltip title={tooltipText || null} placement="top">
        <Typography color="secondary">{title}</Typography>
      </Tooltip>

      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              checked={state === "yes"}
              onChange={() => setState(state === "yes" ? null : "yes")}
              icon={
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    bgcolor: "white",
                    border: disabled ? "1px solid #bfbfbf" : "1px solid #7a7a7a",
                  }}
                />
              }
            />
          }
          disabled={disabled}
          label={yesLabel}
          sx={{ ml: 0, mb: -1 }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={state === "no"}
              onChange={() => setState(state === "no" ? null : "no")}
              icon={
                <Box
                  sx={{
                    width: 16,
                    height: 16,
                    bgcolor: "white",
                    border: disabled ? "1px solid #bfbfbf" : "1px solid #7a7a7a",
                  }}
                />
              }
            />
          }
          disabled={disabled}
          label={noLabel}
          sx={{ mb: -1 }}
        />
      </FormGroup>
    </>
  );
};

export default YesNoCheckBoxes;
